import { Select as AntSelect, SelectProps } from 'antd'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

const StyledSelect = styled(AntSelect)<any>`
  width: 110px;
  .ant-select-arrow {
    color: white;
  }
  .ant-select-selection-item {
    color: white !important;
    display: flex;
    align-items: center;
  }

  &.blue {
    .ant-select-selector {
      background: var(--color-blue-108);
      color: white;
      border-color: var(--color-blue-108);
      &.btn-outline {
        background: white;
        color: var(--color-blue-108);
        &:hover {
          background: var(--color-blue-108);
          color: white;
        }
      }
    }
  }
  &.green {
    .ant-select-selector {
      background: var(--color-primary-108);
      color: white;
      border-color: var(--color-primary-108);
      &.btn-outline {
        background: white;
        color: var(--color-primary-108);
        &:hover {
          background: var(--color-primary-108);
          color: white;
        }
      }
    }
  }
  &.red {
    .ant-select-selector {
      background: var(--color-red-106);
      color: white;
      border-color: var(--color-red-106);
      &.btn-outline {
        background: white;
        color: var(--color-red-106);
        &:hover {
          background: var(--color-red-106);
          color: white;
        }
      }
    }
  }
`

interface IProps extends SelectProps<any, any> {
  title?: string
  color?: 'blue' | 'green' | 'yellow' | 'red'
}

const SelectButton = (props: IProps) => {
  const { t } = useTranslation()
  const { color, placeholder, defaultValue, className, ...resProps } = props
  return (
    <StyledSelect
      className={`${className} ${color}`}
      defaultValue={defaultValue}
      placeholder={t(placeholder?.toString() || '')}
      {...resProps}
    />
  )
}

export default SelectButton
